export function formatPercent(x) {
  return (x * 100).toFixed(1) + " %";
}

export function formatPercent2(x) {
  return (x * 100).toFixed(2) + " %";
}

export function formatPercentN(x, n) {
  return (x * 100).toFixed(n) + " %";
}

export function formatCrypto(x) {
  if (typeof x === "number") {
    return x.toFixed(8);
  } else {
    return null;
  }
}

export function formatFiat(x) {
  if (typeof x === "number") {
    return x.toFixed(2);
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/numberFormat.js